import React from "react";
import TopScorer from "./TopScorer";
import ListItem from "./ListItem";

function RankingList({ data }) {
  return (
    <>
      <TopScorer
        name={data[0]?.nickname}
        points={data[0]?.score}
      />

      <div className="mt-11 w-full max-w-xl">
        <ul className="mb-6 space-y-5">
          {data &&
            data
              .slice(1, 5)
              .map((item, index) => (
                <ListItem
                  key={index}
                  index={index + 1}
                  name={item.nickname}
                  points={item.score}
                />
              ))}
        </ul>
      </div>
    </>
  );
}

export default RankingList;
